module.exports = __webpack_public_path__ + "static/media/hotel-villa-antonio-orebic-family-suite-cover.a517625d.jpg";